// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2IWH3","importantInfo":"styles_importantInfo__3mgZj"};